import { Component, Input } from '@angular/core';
import { Room } from 'src/main/webapp/assets/models/iter.model';

/**
 * Componente per modellare la camera di un albergo.
 */
@Component({
  selector: 'app-room',
  styleUrls: ['./room.component.scss'],
  templateUrl: './room.component.html'
})
export class RoomComponent {

  @Input() public rooms!: Room[];

  public hotelHasMoreThanOneRoom(): boolean {
    return this.rooms.length > 1;
  }

  public getTotalGuests(room: Room): number {
    return (room.adults || 0) + (room.children || 0) + (room.infants || 0);
  }

}
